
<header class="site-header"
        [ngClass]="{'inner-page-header':curr_state!='/',
        'dashboard':is_front_logged !=0 || curr_state=='/patient/messages',
        'aftersignup-header':is_front_logged !=0, 'd-none': curr_state=='/email-verification'}">
  <div class="row refreahTab" *ngIf="showRefresh == 1">
    <div class="boxMessgae" wfd-id="508">
      <div class="">
        <p>
          <img src="assets/images/warning_icon.png" alt="Warning icon" style="width: 20px;margin-right: 12px;top: 4px;position: relative;">
          We found issues loading the page, trying to re-load automatically. &nbsp;
          <a href="javascript:void(0)" (click)="loadRefresh()">click here</a>&nbsp; to reload manually.
        </p>
      </div>
    </div>
  </div>

  <nav id="header" class="navbar navbar-fixed-top">
    <div class="container navbar-container" id="header-container">
      <div class="navbar-header">
        <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar"
                aria-expanded="false" aria-controls="navbar">
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>

        <div [ngClass]="{'logo-name':mydentistid}" class="d-flex align-items-center">
          <a class="navbar-brand" routerLink="/" *ngIf="!mydentistid">
            <img style="width: 100px; margin-top: -10%;" src="assets/images/new-logo.png" alt="DentalChat Logo">
          </a>
          <a class="navbar-brand" href="javascript:void(0)" *ngIf="mydentistid">
            <img style="width: 100px; margin-top: -10%;" src="assets/images/new-logo.png" alt="DentalChat Logo">
          </a>
          <a class="nav navbar-nav" href="javascript:void(0)" *ngIf="mydentistid">
            {{welcomemsg}}
          </a>
        </div>
      </div>

      <div id="navbar" class="navbar-collapse collapse" *ngIf="mobile">
        <!-- Not logged in  -->
        <ul class="nav navbar-nav navbar-left navbar-right" *ngIf="!is_front_logged">
          <li [ngClass]="{'active':curr_state=='/'}">
            <a routerLink="/" data-toggle="collapse" data-target=".navbar-collapse" aria-expanded="false"
               aria-controls="navbar">
              Home
            </a>
          </li>

          <li class="nav-list-business">
            <a (click)="redirectTo('/dentist/list-practice')" class="btn">
              Sign up your practice
            </a>
          </li>

          <li class="nav-list-business" [ngClass]="{ 'active': curr_state == '/dentist/signin' }">
            <a (click)="redirectTo('/dentist/signin')" class="btn">
              Dentist Sign In
            </a>
          </li>

          <li class="nav-dbl">
            <span class="btn btn-sign-secondary">
              <a (click)="redirectTo('/patient/register')">
                Patient Registration
              </a>

              <a  (click)="redirectTo('/patient/login')">
                Patient Log In
              </a>
            </span>
          </li>
        </ul>

        <!-- For customer section  -->
        <ul class="nav navbar-nav navbar-left navbar-right" *ngIf="is_front_logged==4">
          <li [ngClass]="{ 'hide4mydentist':mydentistid }">
            <a routerLink="/" data-toggle="collapse" data-target=".navbar-collapse" aria-expanded="false"
               aria-controls="navbar">
              Home
            </a>
          </li>

          <li>
            <a routerLink="/customer/profile" data-toggle="collapse" data-target=".navbar-collapse"
               aria-expanded="false" aria-controls="navbar">
              Profile
            </a>
          </li>
          <li>
            <div class="message-icon">
              <a href="javascript:void(0)" routerLink="/customer/messages" class="btn navMsg-icon" data-toggle="collapse"
                 data-target=".navbar-collapse" aria-expanded="false" aria-controls="navbar">
                Message
              </a>
            </div>
          </li>

          <li>
            <div class="profile-img">
              <a routerLink="/customer/vendor/profile" data-toggle="collapse" data-target=".navbar-collapse"
                 aria-expanded="false" aria-controls="navbar">
                <img [hidden]="!(loginType==1)" width="50"
                     src="{{base_url}}/uploads/patient_profile_image/{{(user_profile_pics && user_profile_pics!='')?user_profile_pics:'no_image.jpg'}}"
                     (error)="onErrorDefaultImage($event)" alt="Profile img"/>
                <img [hidden]="!(loginType!=1)" width="50"  (error)="onErrorDefaultImage($event)">
              </a>
            </div>

            <div class="dropdown">
              <span>Welcome </span>

              <a href="javascript:void(0);" class="dropdown-toggle hdrname" data-toggle="dropdown">
                <ng-container>{{ logged_user_name | slice:0:15 }}</ng-container>
                <i class="fa fa-angle-down" aria-hidden="true"></i>
              </a>

              <ul class="dropdown-menu">
                <li>
                  <a routerLink="/customer/change-password" data-toggle="collapse" data-target=".navbar-collapse"
                     aria-expanded="false" aria-controls="navbar">
                    Change Password
                  </a>
                </li>

                <li>
                  <a (click)="patientLogout()" data-toggle="collapse" data-target=".navbar-collapse"
                     aria-expanded="false" aria-controls="navbar">
                    Log out
                  </a>
                </li>
              </ul>
            </div>
          </li>

          <li>
            <a href="javascript:void(0)" routerLink="/customer/create-post" class="btn btn-warning btn-post"
               data-toggle="collapse" data-target=".navbar-collapse" aria-expanded="false" aria-controls="navbar">
              Create New Request
            </a>
          </li>

          <li>
            <a href="javascript:void(0)" routerLink="/customer/dashboard" class="btn btn-warning btn-post"
               data-toggle="collapse" data-target=".navbar-collapse" aria-expanded="false" aria-controls="navbar">
              Dashboard
            </a>
          </li>
        </ul>
        <!-- End customer section -->

        <!-- For agent section  -->
        <ul class="nav navbar-nav navbar-left navbar-right" *ngIf="is_front_logged==3">
          <li [ngClass]="{ 'hide4mydentist': mydentistid }">
            <a routerLink="/" data-toggle="collapse" data-target=".navbar-collapse" aria-expanded="false"
               aria-controls="navbar">
              Home
            </a>
          </li>

          <li>
            <a routerLink="/marketplace/vendor/profile" data-toggle="collapse" data-target=".navbar-collapse"
               aria-expanded="false" aria-controls="navbar">
              Profile
            </a>
          </li>

          <li>
            <div class="message-icon">
              <a href="javascript:void(0)" routerLink="/marketplace/vendor/messages" class="btn navMsg-icon"
                 data-toggle="collapse" data-target=".navbar-collapse" aria-expanded="false" aria-controls="navbar">
                Message
              </a>
            </div>
          </li>

          <li>
            <div class="profile-img">
              <a routerLink="/marketplace/vendor/profile" data-toggle="collapse" data-target=".navbar-collapse"
                 aria-expanded="false" aria-controls="navbar">
                <img [hidden]="!(loginType==1)" width="50"
                     src="{{base_url}}/uploads/patient_profile_image/{{(user_profile_pics && user_profile_pics!='')?user_profile_pics:'no_image.jpg'}}"
                     (error)="onErrorDefaultImage($event)" alt="Profile img"/>
                <img [hidden]="!(loginType!=1)" width="50"  (error)="onErrorDefaultImage($event)">
              </a>
            </div>

            <div class="dropdown">
              <span>Welcome </span>

              <a href="javascript:void(0);" class="dropdown-toggle hdrname" data-toggle="dropdown">
                <ng-container>{{ logged_user_name | slice:0:15 }}</ng-container>
                <i class="fa fa-angle-down" aria-hidden="true"></i>
              </a>

              <ul class="dropdown-menu">
                <li>
                  <a routerLink="/patient/change-password" data-toggle="collapse" data-target=".navbar-collapse"
                     aria-expanded="false" aria-controls="navbar">
                    Change Password
                  </a>
                </li>
                <li *ngIf="is_switch_acc==1">
                  <a (click)="switchAgentToDentist()" data-toggle="collapse" data-target=".navbar-collapse" aria-expanded="false"
                     aria-controls="navbar">
                    Switch to Dentist
                  </a>
                </li>
                <li>
                  <a (click)="patientLogout()" data-toggle="collapse" data-target=".navbar-collapse"
                     aria-expanded="false" aria-controls="navbar">
                    Log out
                  </a>
                </li>
              </ul>
            </div>
          </li>

          <li>
            <a href="javascript:void(0)" routerLink="/marketplace/vendor/add-product" class="btn btn-warning btn-post"
               data-toggle="collapse" data-target=".navbar-collapse" aria-expanded="false" aria-controls="navbar">
              Add New Product
            </a>
          </li>

          <li>
            <a href="javascript:void(0)" routerLink="/marketplace/vendor/dashboard" class="btn btn-warning btn-post"
               data-toggle="collapse" data-target=".navbar-collapse" aria-expanded="false" aria-controls="navbar">
              Dashboard
            </a>
          </li>
        </ul>
        <!-- End agent section -->

        <!-- For patient section  -->
        <ul class="nav navbar-nav navbar-left navbar-right" *ngIf="is_front_logged==2">
          <li [ngClass]="{ 'hide4mydentist':mydentistid }">
            <a routerLink="/" data-toggle="collapse" data-target=".navbar-collapse" aria-expanded="false"
               aria-controls="navbar">
              Home
            </a>
          </li>

          <li>
            <a routerLink="/patient/profile" data-toggle="collapse" data-target=".navbar-collapse" aria-expanded="false"
               aria-controls="navbar">
              Profile
            </a>
          </li>

          <li>
            <div class="message-icon">
              <a href="javascript:void(0)" routerLink="/patient/messages" class="btn navMsg-icon" data-toggle="collapse"
                 data-target=".navbar-collapse" aria-expanded="false" aria-controls="navbar">
                Message
              </a>
            </div>
          </li>

          <li>
            <div class="profile-img">
              <a routerLink="/patient/profile" data-toggle="collapse" data-target=".navbar-collapse"
                 aria-expanded="false" aria-controls="navbar">
                <img [hidden]="!(loginType==1)" width="50"
                     src="{{base_url}}/uploads/patient_profile_image/{{(user_profile_pics && user_profile_pics!='')?user_profile_pics:'no_image.jpg'}}"
                     (error)="onErrorDefaultImage($event)" alt="Profile img"/>
                <img [hidden]="!(loginType!=1)" width="50"  (error)="onErrorDefaultImage($event)">
              </a>
            </div>

            <div class="dropdown">
              <span>Welcome </span>
              <a href="javascript:void(0);" class="dropdown-toggle hdrname" data-toggle="dropdown">
                <ng-container>{{ logged_user_name | slice:0:15 }}</ng-container>
                <i class="fa fa-angle-down" aria-hidden="true"></i>
              </a>

              <ul class="dropdown-menu">
                <li>
                  <a routerLink="/patient/change-password" data-toggle="collapse" data-target=".navbar-collapse"
                     aria-expanded="false" aria-controls="navbar">
                    Change Password
                  </a>
                </li>

                <li>
                  <a (click)="patientLogout()" data-toggle="collapse" data-target=".navbar-collapse"
                     aria-expanded="false" aria-controls="navbar">
                    Log out
                  </a>
                </li>
              </ul>
            </div>
          </li>

          <li>
            <a href="javascript:void(0)" routerLink="/patient/create-post" class="btn btn-warning btn-post"
               data-toggle="collapse" data-target=".navbar-collapse" aria-expanded="false" aria-controls="navbar">
              Create New Request
            </a>
          </li>

          <li>
            <a href="javascript:void(0)" routerLink="/patient/posts" class="btn btn-warning btn-post"
               data-toggle="collapse" data-target=".navbar-collapse" aria-expanded="false" aria-controls="navbar">
              Dashboard
            </a>
          </li>
        </ul>
        <!-- End patient section -->

        <!-- For doctor -->
        <ul class="nav navbar-nav navbar-left navbar-right" *ngIf="is_front_logged==1">
          <li [ngClass]="{'active':curr_state=='/'}">
            <a routerLink="/" data-toggle="collapse" data-target=".navbar-collapse" aria-expanded="false"
               aria-controls="navbar">
              Home
            </a>
          </li>
          <li>
            <a routerLink="/dentist/settings" data-toggle="collapse" data-target=".navbar-collapse"
               aria-expanded="false" aria-controls="navbar">
              Profile
            </a>
          </li>
          <li id="message">
            <a href="javascript:void(0)" (click)="redirectFromMessage()" class="btn" data-toggle="collapse"
               data-target=".navbar-collapse" aria-expanded="false" aria-controls="navbar">
              Message
            </a>
          </li>
          <li>
            <div class="profile-img">
              <a routerLink="dentistsettings" data-toggle="collapse" data-target=".navbar-collapse"
                 aria-expanded="false" aria-controls="navbar">
                <img width="50"
                     src="{{base_url}}/uploads/dentist_profile_image/{{(user_profile_pics)?user_profile_pics:'no_image.jpg'}}" alt="Profile img"/>
              </a>
            </div>

            <div class="dropdown">
              <span>Welcome </span>
              <a href="javascript:void(0);" class="dropdown-toggle" data-toggle="dropdown">
                <ng-container>{{logged_user_name | slice:0:15}}
                </ng-container>
                <i class="fa fa-angle-down" aria-hidden="true"></i>
              </a>
              <ul class="dropdown-menu">
                <li>
                  <a routerLink="/dentist/change-password" data-toggle="collapse" data-target=".navbar-collapse"
                     aria-expanded="false" aria-controls="navbar">
                    Change Password
                  </a>
                </li>
                <li>
                  <a routerLink="/dentist/settings" data-toggle="collapse" data-target=".navbar-collapse"
                     aria-expanded="false" aria-controls="navbar">
                    Settings
                  </a>
                </li>
                <li *ngIf="is_switch_acc==1">
                  <a (click)="switchDentistToAgent()" data-toggle="collapse" data-target=".navbar-collapse" aria-expanded="false"
                     aria-controls="navbar">
                    Switch to Vendor
                  </a>
                </li>
                <li>
                  <a (click)="logout()" data-toggle="collapse" data-target=".navbar-collapse" aria-expanded="false"
                     aria-controls="navbar">
                    Log out
                  </a>
                </li>
              </ul>
            </div>
          </li>
          <!-- start new code by vikas -->
          <li *ngIf="!paidPlanExist">
            <div class="header-pkg-wrapper">
              <!-- <a class="header-pkg-btn" routerLink="/patient-leads-listing">Buy local leads</a> -->
              <a class="header-pkg-btn" (click)="upgradeToPremium()">Upgrade to Premium</a>
            </div>
          </li>
          <!-- start new code by vikas -->
        </ul>
        <!-- EoF For doctor -->
      </div>


      <div id="navbar" class="navbar-collapse collapse" *ngIf="!mobile">

        <!-- Not logged in  -->
        <ul class="nav navbar-nav navbar-left navbar-right" *ngIf="!is_front_logged">
          <li [ngClass]="{ 'active': curr_state == '/' }">
            <a routerLink="/">
              Home
            </a>
          </li>

          <li class="nav-list-business" [ngClass]="{'active':curr_state=='/dentist/signin'}">
            <a (click)="redirectTo('/dentist/signin')" class="btn">
              Dentist Log In / Registration
            </a>
          </li>

          <li class="nav-dbl">
            <span class="btn btn-sign-secondary">
              <a  (click)="redirectTo('/patient/login')">
                Patient Log In / Registration
              </a>
            </span>
          </li>
        </ul>

        <!-- For customer section  -->
        <ul class="nav navbar-nav navbar-left navbar-right" *ngIf="is_front_logged == 4">
          <li [ngClass]="{ 'hide4mydentist': mydentistid }">
            <a routerLink="/">
              Home
            </a>
          </li>

          <li>
            <a routerLink="/customer/profile">
              Profile
            </a>
          </li>

          <li>
            <div class="message-icon">
              <a href="javascript:void(0)" routerLink="/customer/messages" class="btn navMsg-icon">Message</a>
            </div>
          </li>

          <li>
            <div class="profile-img">
              <a routerLink="/customer/profile">
                <img [hidden]="loginType==2" width="50"
                     src="{{base_url}}/uploads/patient_profile_image/{{(user_profile_pics && user_profile_pics!='')?user_profile_pics:'no_image.jpg'}}"
                     (error)="onErrorDefaultImage($event)" alt="Profile img"/>
                <img [hidden]="loginType==2" width="50" (error)="onErrorDefaultImage($event)">
              </a>
            </div>

            <div class="dropdown">
              <span>Welcome </span>
              <a href="javascript:void(0);" class="dropdown-toggle hdrname" data-toggle="dropdown">
                <ng-container>{{ logged_user_name | slice:0:15 }}
                </ng-container>
                <i class="fa fa-angle-down" aria-hidden="true"></i>
              </a>

              <ul class="dropdown-menu">
                <li><a routerLink="/customer/change-password">Change Password</a></li>
                <li><a (click)="patientLogout()">Log out</a></li>
              </ul>
            </div>
          </li>

          <li>
            <a href="javascript:void(0)" routerLink="/customer/create-post" class="btn btn-warning btn-post">
              Create New Request
            </a>
          </li>

          <li>
            <a href="javascript:void(0)" routerLink="/customer/dashboard" class="btn btn-warning btn-post">
              Dashboard
            </a>
          </li>
        </ul>
        <!-- End customer section -->

        <!-- For agent section  -->
        <ul class="nav navbar-nav navbar-left navbar-right" *ngIf="is_front_logged==3">
          <li [ngClass]="{ 'hide4mydentist': mydentistid }">
            <a routerLink="/">
              Home
            </a>
          </li>

          <li>
            <a routerLink="/marketplace/vendor/profile">
              Profile
            </a>
          </li>

          <li>
            <div class="message-icon">
              <a href="javascript:void(0)" routerLink="/marketplace/vendor/messages" class="btn navMsg-icon">Message</a>
            </div>
          </li>
          <li>
            <div class="profile-img">
              <a routerLink="/marketplace/vendor/profile">
                <img [hidden]="loginType==2" width="50"
                     src="{{base_url}}/uploads/patient_profile_image/{{(user_profile_pics && user_profile_pics!='')?user_profile_pics:'no_image.jpg'}}"
                     (error)="onErrorDefaultImage($event)" alt="Profile img"/>
                <img [hidden]="loginType==2" width="50" (error)="onErrorDefaultImage($event)">
              </a>
            </div>

            <div class="dropdown">
              <span>Welcome </span>
              <a href="javascript:void(0);" class="dropdown-toggle hdrname" data-toggle="dropdown">
                <ng-container>{{ logged_user_name | slice:0:15 }}
                </ng-container>
                <i class="fa fa-angle-down" aria-hidden="true"></i>
              </a>

              <ul class="dropdown-menu">
                <li>
                  <a routerLink="/patient/change-password">
                    Change Password
                  </a>
                </li>
                <li *ngIf="is_switch_acc==1">
                  <a (click)="switchAgentToDentist()">
                    Switch to Dentist
                  </a>
                </li>
                <li>
                  <a (click)="patientLogout()">
                    Log out
                  </a>
                </li>
              </ul>
            </div>
          </li>

          <li>
            <a href="javascript:void(0)" routerLink="/marketplace/vendor/add-product" class="btn btn-warning btn-post">
              Add New Product
            </a>
          </li>

          <li>
            <a href="javascript:void(0)" routerLink="/marketplace/vendor/dashboard" class="btn btn-warning btn-post">
              Dashboard
            </a>
          </li>
        </ul>
        <!-- End agent section -->

        <!-- For patient section  -->
        <ul class="nav navbar-nav navbar-left navbar-right" *ngIf="is_front_logged==2">
          <li [ngClass]="{ 'hide4mydentist': mydentistid }">
            <a routerLink="/">
              Home
            </a>
          </li>

          <li>
            <a routerLink="/patient/profile">
              Profile
            </a>
          </li>

          <li>
            <div class="message-icon">
              <a href="javascript:void(0)" routerLink="/patient/messages" class="btn navMsg-icon">Message</a>
            </div>
          </li>

          <li>
            <div class="profile-img">
              <a routerLink="/patient/profile">
                <img [hidden]="loginType==2" width="50"
                     src="{{base_url}}/uploads/patient_profile_image/{{(user_profile_pics && user_profile_pics!='')?user_profile_pics:'no_image.jpg'}}"
                     (error)="onErrorDefaultImage($event)" alt="Profile img"/>
                <img [hidden]="loginType==2" width="50" (error)="onErrorDefaultImage($event)">
              </a>
            </div>

            <div class="dropdown">
              <span>Welcome </span>
              <a href="javascript:void(0);" class="dropdown-toggle hdrname" data-toggle="dropdown">
                <ng-container>{{ logged_user_name | slice:0:15 }}</ng-container>
                <i class="fa fa-angle-down" aria-hidden="true"></i>
              </a>

              <ul class="dropdown-menu">
                <li>
                  <a routerLink="/patient/change-password">
                    Change Password
                  </a>
                </li>
                <li>
                  <a (click)="patientLogout()">
                    Log out
                  </a>
                </li>
              </ul>
            </div>
          </li>

          <li>
            <a href="javascript:void(0)" routerLink="/patient/create-post" class="btn btn-warning btn-post">
              Create New Request
            </a>
          </li>

          <li>
            <a href="javascript:void(0)" routerLink="/patient/posts" class="btn btn-warning btn-post">
              Dashboard
            </a>
          </li>
        </ul>
        <!-- End patient section -->

        <!-- For doctor -->
        <ul class="nav navbar-nav navbar-left navbar-right" *ngIf="is_front_logged==1">
          <li [ngClass]="{ 'active': curr_state == '/' }">
            <a routerLink="/">Home</a>
          </li>

          <li>
            <a routerLink="/dentist/settings">
              Profile
            </a>
          </li>
          <li>
            <div class="dropdown">
              <a href="javascript:void(0);" class="dropdown-toggle" id="notification" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fa fa-bell" aria-hidden="true"></i>
              </a>
              <ul class="dropdown-menu" aria-labelledby="notification" style="width: fit-content;">
                <dc-notifications></dc-notifications>
              </ul>
            </div>
          </li>

          <li id="message">
            <a href="javascript:void(0)" (click)="redirectFromMessage()" class="btn">
              Message
            </a>
          </li>

          <li>
            <div class="profile-img">
              <a routerLink="/dentist/settings">
                <img width="50"
                     src="{{base_url}}/uploads/dentist_profile_image/{{(user_profile_pics)?user_profile_pics:'no_image.jpg'}}" alt="Profile img"/>
              </a>
            </div>

            <div class="dropdown">
              <span>Welcome </span>
              <a href="javascript:void(0);" class="dropdown-toggle" data-toggle="dropdown">
                <ng-container>{{logged_user_name | slice:0:15}}
                </ng-container>
                <i class="fa fa-angle-down" aria-hidden="true"></i>
              </a>

              <ul class="dropdown-menu">
                <li>
                  <a routerLink="/dentist/change-password">
                    Change Password
                  </a>
                </li>

                <li>
                  <a routerLink="/dentist/settings">
                    Settings
                  </a>
                </li>
                <li *ngIf="is_switch_acc==1">
                  <a (click)="switchDentistToAgent()">
                    Switch to Vendor
                  </a>
                </li>
                <li>
                  <a (click)="logout()">
                    Log out
                  </a>
                </li>
              </ul>
            </div>
          </li>

          <!-- start new code by vikas -->
          <li *ngIf="!paidPlanExist">
            <div class="header-pkg-wrapper">
              <!-- <a class="header-pkg-btn" routerLink="/patient-leads-listing">
                Buy local leads
              </a> -->

              <a class="header-pkg-btn" (click)="upgradeToPremium()">
                Upgrade to Premium
              </a>
            </div>
          </li>
          <!-- start new code by vikas -->
        </ul>
        <!-- EoF For doctor -->

      </div>
    </div>
  </nav>
</header>
